import {
  animate,
  state,
  style,
  transition,
  trigger,
} from '@angular/animations';

import {
  Component,
  input,
  model,
  output,
  signal,
} from '@angular/core';
import type { FormCheckboxControl } from '@angular/forms/signals';
import type { IconName } from '../icon';
import { Icon } from '../icon';

@Component({
  selector: 'tvd-toggle',
  imports: [Icon],
  templateUrl: './toggle.html',
  animations: [
    trigger('slideRight', [
      state('activeWithText', style({ transform: 'translateX(250%)' })),
      state('active', style({ transform: 'translateX(150%)' })),
      state('inactive', style({ transform: 'translateX(0)' })),
      transition('true <=> false', animate('0.3s ease-in-out')),
    ]),
    trigger('slideRightHover', [
      state('activeWithText', style({ transform: 'translateX(125%)' })),
      state('active', style({ transform: 'translateX(75%)' })),
      state('inactive', style({ transform: 'translateX(0)' })),
      transition('true <=> false', animate('0.3s ease-in-out')),
    ]),
  ],
})
export class Toggle implements FormCheckboxControl {
  readonly iconOn = input<IconName>();
  readonly iconOff = input<IconName>();

  readonly id = signal('');

  readonly checked = model(false);
  readonly disabled = input(false);
  readonly touched = model(false);
  /** Tells the bound field it has been touched (signal-forms `touch` output). */
  readonly touch = output<void>();
  readonly loading = input(false);
  /** Drives the asterisk; bound from the field schema by `[formField]`. */
  readonly required = input(false);

  toggle(): void {
    if (!this.disabled()) {
      const checked = !this.checked();
      this.checked.set(checked);
      this.touched.set(true);
      this.touch.emit();
    }
  }
}
